/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : common.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";

const domain = "cookist.bar";
const host = "api." + domain;
const secure = true;

export const commonConfig: PropertyConfig = {
    version: "8.0.0",
    debug: true,
    host: host,
    domain: domain,
    site: "cookist",
    siteName: "Cookist.com",
    mainUrl: "https://www.cookist.bar",
    assetsDistro: "https://api.cookist.bar",
    assetsCacheBuster: "1671031069",
    serverSdkEndpoint: "/embed/channel70",
    sdkJsServer: {
        domain: domain,
        host: domain,
        path: "/local/cookist-com/sdk/cookist-com-server-sdk-dev.js",
        secure: true
    },
    secure: secure,
    applicationToken: {

        web: "837923090086|fWJ8p199Ro2YATHL32AM0dkCutkajehUftq2rlNamWcSpuyrjO2dnrIHAXy2PFED",
        ios: "129928336241|KcPlfruKgcb66ryJrEPGYRCdozM3XuvekEJ33rJIv2NzrhtxzHQ5n8g9YcBdozqV",
        android: "832292087438|HfWMtjmtBdp1dnCzahniI5d6n6dC3Iypc12QE1uL6YHrBbM0eVTxmJIOxdYIXQK7"
    },
    cookies: {
        names: {
            session: "ckcom_ut",
            logout: "ckcom_lo",
            fbToken: "ckcom_fbtk",
            aes: "fp_ad",
            loginPreviousState: "ckcom_lpsnu",
            lastLoginProvider: "ckcom_lprov",
            audienceToken: "apat"
        },
        cookieDomain: ".cookist.bar",
        cookieversion: 8,
    },
    loginManager: {
        barrierDisplayMode: BarrierDisplayMode.SHOW_DIALOG,
        actual_providers: {
            facebook: {
                enabled: true,
                applicationIdentifier: "588659546040321",
                scopes: ["public_profile", "email", "user_birthday", "user_gender"]
            },
            google: {
                enabled: true,
                applicationIdentifier: "449324688507-1dcq6vl9amshvdc66o1veskijklqpsn7.apps.googleusercontent.com",
                scopes: ["https://www.googleapis.com/auth/user.gender.read", "https://www.googleapis.com/auth/user.birthday.read"]
            },
            apple: {
                enabled: true,
                scopes: ['email', 'name'],
                // @note workaround perchè non utilizzato direttamente
                applicationIdentifier: ""
            },
            email: {
                enabled: true,
                scopes: [],
                applicationIdentifier: ""
            }
        },
        /**
         * firebase app configuration goes here
         */
        firebase: {
            apiKey: "AIzaSyDljZm_QiAas6ec7glkgVgUj2cn4KZAeaU",
            authDomain: "cookistcom-users.firebaseapp.com",
            projectId: "cookistcom-users",
            storageBucket: "cookistcom-users.appspot.com",
            messagingSenderId: "449324688507",
            appId: "1:449324688507:web:e2bd17158c1b21ff46eede",
            measurementId: "G-STC373VPMD"
        },
        autologin: {
            enabled: true,
            retrieveActualDataAlways: false,
        },
        firebaseAccountMergeEnable: true,
        revokeOnClientSideOnDeletion: true
    },
    // parse: {
    //     login: false,
    //     follows: true,
    //     bookmarks: true
    // },
    support: {
        native_apps: true,
        bookmarks: true,
        newsletters: false
    },
    nativeApp: {
        disabled: true,
        product: "cookist_com",
        schema_intent: "cookistcom",
        ios_alternative_url: "https://cooki.st/cookist-wow-ios",
        android_alternative_url: "https://cooki.st/cookist-wow-android",
        dynamicLink: {
            baseUrl: "https://cookistcom.page.link/app",
            apn: "com.ciaopeople.fanpage.cookist",
            amv: "3",
            ibi: "com.ciaopeople.fanpage.cookist",
            isi: "1248743030",
            ius: "cookistcom"
        }
    },
    webPush: {
        publicKey: "BDsidfbNjQx4wxk9KGuUJvmogzXWuX4fNLcU6tNQJk7v7s6uh3gIT-77D2WcQ4NlsrZnljwzXsSl2r3-HgkywoM",
        vapiKey: "BDsidfbNjQx4wxk9KGuUJvmogzXWuX4fNLcU6tNQJk7v7s6uh3gIT-77D2WcQ4NlsrZnljwzXsSl2r3-HgkywoM",
        serviceWorkerPath: "/serviceworker/v7/sw.js",
        serviceWorkerHost: "cookist.bar"
    },
    snhubConfig: {
        host: host,
        domain: domain,
        secure: secure,
        enabled: true,
        cookies: {
            userdata: "fp_snu_ud",
            token: "fp_snu_tk",
            oldToken: "fp_snu_oldtk",
            next_check: "fp_snu_nc",
            role: "fp_snu_role" 
        }
    },
    ga4: {
        accountId: "G-TMYJKFQ0NL",
        cookieDomain: ".cookist.bar"
    },
    contacts: {
        dataDeletionEmail: "richieste-cancellazione@cookist.com" 
    },
    appDownloadLink: {
        "app-store": "https://apps.apple.com/it/app/cookistwow/id1248743030",
        "google-play": "https://play.google.com/store/apps/details?id=com.ciaopeople.fanpage.cookist"
    },
    links: {
        privacyPolicy: 'https://www.cookist.com/privacy-policy/'
    }
};
